/* tslint:disable */
type CheckType =
  'LessThan' |
  'LessThanOrEqual' |
  'Equal' |
  'NotEqual' |
  'GreaterThan' |
  'GreaterThanOrEqual';
module CheckType {
  export const LESS_THAN: CheckType = 'LessThan';
  export const LESS_THAN_OR_EQUAL: CheckType = 'LessThanOrEqual';
  export const EQUAL: CheckType = 'Equal';
  export const NOT_EQUAL: CheckType = 'NotEqual';
  export const GREATER_THAN: CheckType = 'GreaterThan';
  export const GREATER_THAN_OR_EQUAL: CheckType = 'GreaterThanOrEqual';
  export function values(): CheckType[] {
    return [
      LESS_THAN,
      LESS_THAN_OR_EQUAL,
      EQUAL,
      NOT_EQUAL,
      GREATER_THAN,
      GREATER_THAN_OR_EQUAL
    ];
  }
}

export { CheckType }